module.exports = __webpack_public_path__ + "fonts/ionicons.ef4a9f28.ttf";